/**
 * Overlay semi-transparente que aparece atrás de dropdowns/popovers da página
 * de Operações. Click no overlay = fecha o popover (via `onClose`).
 *
 * - `position: fixed` + `inset: 0` cobre a viewport inteira.
 * - `z-index: 199` fica ABAIXO dos dropdowns (que usam z-index 200+).
 * - Cor rgba(0,0,0,0.65) (definida na spec do projeto) — escurece a página
 *   pra dar destaque ao popover sem esconder completamente o contexto.
 *
 * Uso:
 *   <Backdrop open={isOpen} onClose={() => setIsOpen(false)} />
 *   <div style={{ ...dropdownStyle, zIndex: 200 }}>conteúdo</div>
 */
export function Backdrop({ open, onClose }) {
    if (!open) return null;
    return (
        <button
            type="button"
            aria-hidden="true"
            tabIndex={-1}
            onClick={onClose}
            data-faid="Dropdown_Backdrop_Operacoes"
            style={{
                position: 'fixed',
                inset: 0,
                background: 'rgba(0, 0, 0, 0.65)',
                zIndex: 199,
                border: 'none',
                padding: 0,
                margin: 0,
                cursor: 'default',
                outline: 'none',
            }}
        />
    );
}
